
import { IconArrowDown } from '@ds/icons/IconArrowDown'

import translations from './Introduction.translations'

export default {
  components: {
    IconArrowDown,
  },
  computed: {
    translations: () => translations,
  },
}
